/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Comingsoon1Inputs */

const en_comingsoon1 = /** @type {(inputs: Comingsoon1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Soon`)
};

const de_comingsoon1 = /** @type {(inputs: Comingsoon1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demnächst verfügbar`)
};

/**
* | output |
* | --- |
* | "Coming Soon" |
*
* @param {Comingsoon1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const comingsoon1 = /** @type {((inputs?: Comingsoon1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Comingsoon1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_comingsoon1(inputs)
	return de_comingsoon1(inputs)
});
export { comingsoon1 as "comingSoon" }